var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 39,
    viewBox: "0 0 25 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333344 12.5301C0.333344 6.08052 5.66867 0.833374 12.2267 0.833374C18.7847 0.833374 24.12 6.08052 24.083 12.5301C24.083 14.9715 23.3419 17.34 21.8599 19.3441L21.5635 19.7814L15.376 28.3809C15.376 28.3809 14.5979 29.5834 12.9677 29.5834H12.5972H11.9673H11.4857C9.81837 29.5834 9.07735 28.3809 9.07735 28.3809L2.88985 19.7814L2.5564 19.3441C1.11141 17.34 0.333344 14.9715 0.333344 12.5301ZM16.7839 16.3926L17.1174 15.9554C17.8584 14.9351 18.266 13.769 18.266 12.4937C18.266 9.21423 15.5613 6.55422 12.2267 6.55422C8.8921 6.55422 6.18738 9.21423 6.18738 12.4937C6.18738 13.7326 6.59494 14.9351 7.33596 15.9554L7.66942 16.4291L12.2267 22.7329L16.7839 16.3926ZM12.2083 32.0834C10.4176 32.0834 9.08334 33.4762 9.08334 35.2262C9.08334 36.9048 10.4176 38.2977 12.1732 38.3334C13.9991 38.3334 15.3333 36.9405 15.3333 35.2262V35.1905C15.3333 33.4762 13.9991 32.0834 12.2083 32.0834Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4e8e3e1a0caba3833ddee7bf7302a567.svg";
export { ForwardRef as ReactComponent };